import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import SimpleReactValidator from 'simple-react-validator';
import * as authAction from '../../actions/authAction';
import { Helmet } from 'react-helmet';
import Loader from '../../components/Loader';
import ReCAPTCHABlock from "../../components/ReCAPTCHABlock";

class RegistrationPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            email: '',
            contact_number: '',
            password: '',
            password_confirmation: '',
            hidden: true,
        };
        this.recaptchaRef = React.createRef();
        this.validator = new SimpleReactValidator();
        this.handleChange = this.handleChange.bind(this);
        this.toggleShow = this.toggleShow.bind(this);
    }
    verifySubmit = (evt) => {
        evt.preventDefault();
        this.recaptchaRef.execute();
    }

    verifiedSubmit = () => {
        if (!this.validator.allValid()) {
            this.validator.showMessages();
            this.forceUpdate();
            return false;
        }

        this.props.registration(this.state.name, this.state.email, this.state.contact_number, this.state.password, this.state.password_confirmation, this.props.history);
    }

    handleChange(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    toggleShow() {
        this.setState({ hidden: !this.state.hidden });
    }

    render() {
        return (
            <section class="middle-wrapper">
                <div className="container flex v-center">
                    <Helmet>
                        <title>Registration</title>
                    </Helmet>
                    <ReCAPTCHABlock ref={el => this.recaptchaRef = el} onSubmit={this.verifiedSubmit} />
                    <div className="form-div">
                        <h2>Welcome to daisy</h2>
                        <p>If this is your first visit to the daisy, Login with your User ID as normal. You can then confirm an email address for future sign-ins.</p>
                        <div>
                            <Loader />
                            <form onSubmit={this.verifySubmit} className="form">
                                <div className="form-field">
                                    <input type="name" className="form-control" placeholder="Name" id="name" name="name" value={this.state.name} onChange={this.handleChange} autoComplete="name" />
                                    {this.validator.message('name', this.state.name, 'required')}
                                </div>
                                <div className="form-field">
                                    <input type="email" className="form-control" placeholder="Email" id="email" name="email" value={this.state.email} onChange={this.handleChange} autoComplete="email" />
                                </div>
                                <div className="form-field">
                                    <input type="number" className="form-control" placeholder="Mobile" id="contact_number" name="contact_number" value={this.state.contact_number} onChange={this.handleChange} autoComplete="email" />
                                    {this.validator.message('contact_number', this.state.contact_number, 'required')}
                                </div>
                                <div className="form-field pass-show">
                                    <input type={this.state.hidden ? "password" : "text"} className="form-control" placeholder="Password" id="password" name="password" value={this.state.password} onChange={this.handleChange} autoComplete="new-password" />
                                    {this.validator.message('password', this.state.password, 'required')}
                                    <i className={this.state.hidden ? "pass-show" : "pass-hide"} onClick={this.toggleShow}></i>
                                </div>
                                <div className="form-field pass-show">
                                    <input type={this.state.hidden ? "password" : "text"} className="form-control" placeholder="Confirm Password" id="password_confirmation" name="password_confirmation" value={this.state.password_confirmation} onChange={this.handleChange} autoComplete="new-password" />
                                    {this.validator.message('password_confirmation', this.state.password_confirmation, 'required')}
                                    <i className={this.state.hidden ? "pass-show" : "pass-hide"} onClick={this.toggleShow}></i>
                                </div>
                                <div className="form-field">
                                    <button type="submit" className="btn">Sign Up</button>
                                </div>
                                <p className="text-center">Already have an account ? <Link to="/Login" className='link-color'>Login now</Link></p>
                            </form>
                        </div>
                    </div>
                    <div className="banner">
                        <img src="images/banner.png" alt="banner" />
                    </div>
                </div>
            </section>);
    }
}

const mapStateToProps = (state) => ({
    authenticated: state.session.authenticated
});

const mapActionsToProps = ({
    registration: authAction.registration
})

export default connect(mapStateToProps, mapActionsToProps)(RegistrationPage);